var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKreditpartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 298.9 76.3",
    style: {
      enableBackground: "new 0 0 298.9 76.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:white;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:white;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.6,69.7c-2.9-4.2-7-9.1-11.5-12.9v12.9h-3.9V42.6h3.9v11.3l10.4-11.3h4.8L77.7,55.1 c4.8,3.8,9.6,9.8,12.7,14.6H85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.9,53.5c-3.8,0-5.6,3.1-5.6,5.6v10.7h-3.8V50h3.6l0.1,3.7c1.1-2.3,3-3.9,5.6-3.9c0.7,0,1.2,0.1,1.5,0.1 v3.6C104.1,53.5,103.5,53.5,102.9,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.3,61h-12.6c0.3,4,2.2,6.2,6,6.2c1.7,0,3.6-0.3,4.7-0.6l0.7,2.9c-1.6,0.5-3.5,0.7-6,0.7 c-6,0-9.4-4-9.4-10.3c0-6.2,3.1-10.4,8.7-10.4c5.3,0,8,3.3,8,9.2C123.4,59.5,123.3,60.4,123.3,61z M119.4,57.4 c0-3.2-1.3-5.1-4.1-5.1c-3,0-4.5,2.2-4.7,6h8.8V57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.3,69.7l-0.1-2.5c-1.3,2-3.1,2.9-5.7,2.9c-4.5,0-7.8-3-7.8-10.1c0-6.7,3.6-10.4,8.3-10.4 c2.6,0,4.3,1,5.1,1.9V41.1h3.8v28.7H140.3z M140.2,54.7c-0.9-0.9-2.1-1.9-4.3-1.9c-3,0-5,2.6-5,7.2c0,3.8,1,7,4.6,7 c3,0,4.8-2.4,4.8-6.2V54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.8,69.7V52.8c-0.7-0.1-1.8-0.3-2.6-0.3V50h6.4v19.7H150.8z M152.2,46.1c-1.4,0-2.5-1.1-2.5-2.3 c0-1.3,1.1-2.4,2.5-2.4c1.3,0,2.5,1.1,2.5,2.4C154.7,45,153.5,46.1,152.2,46.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.4,70.1c-3.9,0-5.5-2.2-5.5-5.8V52.9h-3.1v-3h3.1v-4.4c1.1-0.4,2.5-1,3.8-1.7V50h5.1v3h-5.1v10.9 c0,2.3,0.8,3.2,2.8,3.2c1,0,2.1-0.2,2.6-0.4l0.7,2.8C170.5,69.9,169,70.1,167.4,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184,70.1c-2.2,0-3.8-0.6-5-1.6v9.1h-3.8V50h3.6l0.1,2.9c0.8-1.6,2.7-3.3,5.9-3.3c4.9,0,7.7,3.5,7.7,10 C192.5,66.2,189.5,70.1,184,70.1z M183.8,52.8c-3.1,0-4.8,3-4.8,7.3v5.1c1.1,1.1,2.5,1.8,4.2,1.8c2.6,0,4-1.4,4.7-3.4 c0.4-1.1,0.5-2.5,0.5-3.9C188.4,55.7,187.2,52.8,183.8,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.5,69.7l-0.1-1.7c-0.9,0.9-3,2.1-5.7,2.1c-3.3,0-6.1-1.6-6.1-6c0-3,1.4-4.9,4.1-6 c1.5-0.6,3.4-0.9,5.7-0.9c0.2,0,1.8,0,2,0v-1.1c0-2.5-1.1-3.7-4.6-3.7c-2.1,0-3.9,0.5-5.5,1.1v-3.1c1.9-0.5,3.7-0.9,6.3-0.9 c5.3,0,7.6,2,7.6,6.6v13.6H207.5z M207.4,60H206c-4.4,0-6.5,1-6.5,4c0,1.6,0.8,3.2,3.4,3.2c2,0,3.6-0.9,4.6-1.8V60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.6,53.5c-3.8,0-5.6,3.1-5.6,5.6v10.7h-3.8V50h3.6l0.1,3.7c1.1-2.3,3-3.9,5.6-3.9c0.7,0,1.2,0.1,1.5,0.1 v3.6C226.8,53.5,226.2,53.5,225.6,53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.3,70.1c-3.9,0-5.5-2.2-5.5-5.8V52.9h-3.1v-3h3.1v-4.4c1.1-0.4,2.5-1,3.8-1.7V50h5.1v3h-5.1v10.9 c0,2.3,0.8,3.2,2.8,3.2c1,0,2.1-0.2,2.6-0.4l0.7,2.8C240.4,69.9,238.8,70.1,237.3,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.6,69.7V57.1c0-3-1.2-4.3-3.8-4.3c-2.8,0-5,2.4-5,5.4v11.5h-3.8V50h3.6l0.1,2.8c1.2-1.9,3.3-3.2,6.2-3.2 c4.1,0,6.4,2.4,6.4,6.4v13.7H257.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.2,61h-12.6c0.3,4,2.2,6.2,6,6.2c1.7,0,3.6-0.3,4.7-0.6l0.7,2.9c-1.6,0.5-3.5,0.7-6,0.7 c-6,0-9.4-4-9.4-10.3c0-6.2,3.1-10.4,8.7-10.4c5.3,0,8,3.3,8,9.2C282.3,59.5,282.2,60.4,282.2,61z M278.3,57.4 c0-3.2-1.3-5.1-4.1-5.1c-3,0-4.5,2.2-4.7,6h8.8V57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.4,53.5c-3.8,0-5.6,3.1-5.6,5.6v10.7H287V50h3.6l0.1,3.7c1.1-2.3,3-3.9,5.6-3.9c0.7,0,1.2,0.1,1.5,0.1 v3.6C297.5,53.5,296.9,53.5,296.4,53.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.8,69.7h30.3c4.2,0,7.5-3.4,7.5-7.5V45.5H12.8v-4.5h34.8v-3c0-4.2-3.4-7.5-7.5-7.5H9.8 c-4.2,0-7.5,3.4-7.5,7.5v16.7H37v4.5H2.2v3C2.2,66.3,5.6,69.7,9.8,69.7L9.8,69.7z M17.3,18.3c0,4.2,3.4,7.5,7.6,7.5 c4.2,0,7.5-3.4,7.5-7.5c0-4.2-3.4-7.5-7.5-7.5C20.7,10.7,17.3,14.1,17.3,18.3L17.3,18.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKreditpartner);
export default __webpack_public_path__ + "static/media/kreditpartner.ad5e6428ea654a1fc3c605f7e44a259b.svg";
export { ForwardRef as ReactComponent };